export default "__VITE_ASSET__D_U3u4an__"